import { DayButton as OriginalDayButton, type DayButtonProps } from 'react-day-picker';

export default function DayButton({ children, ...props }: DayButtonProps) {
  const dateNumber = props.day.date.getDate();

  return (
    <OriginalDayButton {...props} data-date={dateNumber}>
      {children}
    </OriginalDayButton>
  );
}
